import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import AnimalZakatTable from "./AnimalZakatTable";
import { SERVER_URL } from "./ConstantsIslamicCalculator";
import { Animals_Zakat_EndPoint } from "./ConstantsIslamicCalculator";
import SharedHelmet from "../Helmet";
const TITLE = "حاسبة زكاة الأنعام - احسب زكاة الأنعام بدقة وسهولة ";
const DESCRIPTION =
  "حاسبة زكاة الأنعام هي أداة تستخدم لحساب مبلغ زكاة الأنعام المستحقة وفقًا للأحكام الشرعية في الإسلام. تستخدم هذه الحاسبة لحساب المبلغ المالي الذي يجب دفعه كزكاة على الأنعام مثل الإبل والبقر والأغنام";
const KEYWORDS =
  "حاسبة زكاة الحيوانات, احسب زكاة حيوانك, زكاة الحيوانات, طرق حساب زكاة الحيوانات, مبلغ زكاة الحيوانات, قواعد زكاة الحيوانات, حساب زكاة الحيوانات في الإسلام, زكاة الحيوانات في الشريعة الإسلامية, كيفية حساب زكاة الحيوانات, حاسبة نصاب زكاة الحيوانات, طريقة حساب نصاب زكاة الحيوانات, حاسبة زكاة الأنعام, زكاة الأنعام, حساب زكاة الأنعام, نصاب زكاة الحيوانات في الإسلام";
const OG_URL = "https://do-calculate.com/calculator/ar/animals-zakat/";
const apiEndpoint = `${SERVER_URL}/${Animals_Zakat_EndPoint}`;
function AnimalZakatCalculator() {
  const [camelCount, setCamelCount] = useState(0);
  const [cowCount, setCowCount] = useState(0);
  const [sheepCount, setSheepCount] = useState(0);
  const [result, setRestul] = useState(null);
  const [error, setError] = useState(null);
  const [statusCode, setStatusCode] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const handleCamelCountChange = (event) => {
    setCamelCount(event.target.value);
  };
  const handleCowCountChange = (event) => {
    setCowCount(event.target.value);
  };
  const handleSheepCountChange = (event) => {
    setSheepCount(event.target.value);
  };
  const calculateAnimalsZakat = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(apiEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ camelCount, cowCount, sheepCount }),
      });
      const data = await response.json();
      setStatusCode(response.status);
      if (response.ok) {
        setRestul(data.result);
        setError(null);
      } else {
        setRestul(null);
        setError(data.error);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>احسب زكاة الأنعام</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                حاسبة زكاة الأنعام هي أداة تستخدم لحساب مبلغ زكاة الأنعام
                المستحقة وفقًا للأحكام الشرعية في الإسلام. تستخدم هذه الحاسبة
                لحساب المبلغ المالي الذي يجب دفعه كزكاة على الأنعام مثل الإبل
                والبقر والأغنام
                <br />
                <hr />
              </div>
              <br />
            </div>
            <div className="row">
              <div className="col-12 col-md-5 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  زكاة الحيوانات (الأنعام)
                </div>
                <hr />
                                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="cowCount" className="form-label ms-2">
                      عدد الأبقار{" "}
                    </label>
                  </b>
                  <input
                    type="number"
                    id="cowCount"
                    value={cowCount}
                    onChange={handleCowCountChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                  />
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="sheepCount" className="form-label ms-2">
                      عدد الأغنام{" "}
                    </label>
                  </b>
                  <input
                    type="number"
                    id="sheepCount"
                    value={sheepCount}
                    onChange={handleSheepCountChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                  />
                </div>
                <br/>                <hr />
                <button
                  className="btn btn-success"
                  style={{ fontSize: "20px" }}
                  onClick={calculateAnimalsZakat}
                       >
                    احسب
                    </button>              </div>
              <div className="col-12 col-md-7">
                <br />
                {statusCode === 400 && (
                  <div className="alert alert-warning">
                    <b>
                      <u> حدث خطأ :</u>
                    </b>{" "}
                    يُرجى إدخال جميع الحقول بالشكل الصحيح.{" "}
                  </div>
                )}
                {result && (
                  <div>
                    <h4>
                      <div className="p-3 mb-2 bg-success text-white">
                        النتائج:{" "}
                      </div>
                    </h4>
                    <hr />
                    <AnimalZakatTable result={result}></AnimalZakatTable>
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                وصف حاسبة زكاة الحيوانات (الأنعام){" "}
              </div>
              <div className="info-section-body">
                <u>
                  <b> حاسبة زكاة الحيوانات (الأنعام) </b>{" "}
                </u>{" "}
                <br/>                تقوم الحاسبة بتحليل عدد الحيوانات وفقًا للمعايير المحددة في
                الشرع الإسلامي، مثل الحد الأدنى والحد الأقصى لعدد الحيوانات،
                وتحسب المبلغ الزكوي المستحق وتقدم وصفًا لكل فئة من الحيوانات
                والمبلغ المطلوب دفعه وفقًا لتلك الفئة
                <br/>                باستخدام الحاسبة، يمكن للمستخدم إدخال عدد الإبل والبقر والأغنام
                التي يملكها، ومن ثم يتم حساب مبلغ الزكاة المستحقة بناءً على
                القواعد والمعايير الشرعية. يتم توفير وصف مفصل لكل فئة من
                الحيوانات والمبلغ المطلوب دفعه، مما يساعد المستخدم على فهم
                القواعد والمتطلبات المتعلقة بزكاة الأنعام.
                <br/>                باستخدام حاسبة زكاة الأنعام، يصبح من السهل والمريح للمسلمين حساب
                وتحديد المبلغ الزكوي المستحق على الأنعام الخاصة بهم والوفاء
                بالتزاماتهم الشرعية.
                 <br/>
                <hr />
                <b>تاريخ اخر مراجعة : </b>
                28/02/2026
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default AnimalZakatCalculator;
